var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { merge } from "lodash";
import createMuiPalette from "@material-ui/core/styles/createPalette";
import { colors, getShadeOfColor } from "./colors";
import { colors as figmaColors } from "./generated";
export var createPalette = function (_a) {
    if (_a === void 0) { _a = {}; }
    var primary = _a.primary, secondary = _a.secondary, overrides = __rest(_a, ["primary", "secondary"]);
    var defaultOptions = __assign({ primary: primary || colors.purple, secondary: secondary || __assign(__assign({}, colors.purple), { 
            // these colors are secondary specific
            A400: colors.purple[500], A200: colors.purple[300], A700: colors.purple[700] }), text: {
            hint: figmaColors.text.light,
            primary: figmaColors.text.dark,
            secondary: figmaColors.text.light,
            disabled: figmaColors.text.light,
        }, warning: {
            light: getShadeOfColor("yellow", "lightest"),
            main: getShadeOfColor("yellow", "base"),
            dark: getShadeOfColor("yellow", "darkest"),
        }, error: {
            light: getShadeOfColor("red", "lightest"),
            main: getShadeOfColor("red", "base"),
            dark: getShadeOfColor("red", "darkest"),
        }, success: {
            light: getShadeOfColor("green", "lightest"),
            main: getShadeOfColor("green", "base"),
            dark: getShadeOfColor("green", "darkest"),
        }, info: {
            light: getShadeOfColor("blue", "lightest"),
            main: getShadeOfColor("blue", "base"),
            dark: getShadeOfColor("blue", "darkest"),
        }, action: {
            disabledOpacity: 0.5,
            disabledBackground: getShadeOfColor("neutral", "lightest"),
        }, background: {
            paper: figmaColors.neutral.white,
            default: figmaColors.neutral.white,
        }, border: {
            light: getShadeOfColor("neutral", "lighter"),
            dark: getShadeOfColor("neutral", "light"),
        }, divider: getShadeOfColor("neutral", "lighter"), grey: colors.neutral }, colors);
    return createMuiPalette(merge(defaultOptions, overrides));
};
